import { useEffect, useMemo } from "react";
import classes from "./Report.module.css";
import BoxWrapper from "../../../../../components/ui/boxWrapper";

function MatchedInvoice({ matchedInvoiceData, onTabClick, loading }) {
  useEffect(() => {
    onTabClick();
  }, [onTabClick]);

  const rows = useMemo(() => {
    if (loading) {
      return (
        <tr>
          <td colSpan={11} className={classes.loader}>
            Loading...
          </td>
        </tr>
      );
    }
    const matchedData = matchedInvoiceData?.record?.matched || [];

    if (!matchedData.length) {
      return (
        <tr>
          <td colSpan={17} className={classes.noData}>
            No Data Found!
          </td>
        </tr>
      );
    }

    return matchedData.map((invoice, index) => (
      <tr key={index}>
        <td>{invoice.GSTIN}</td>
        <td>{invoice.Vendor_Name}</td>
        <td>{invoice.DOC_NUMBER}</td>
        <td>{invoice.DOC_DATE}</td>
        <td>{invoice.DOC_TYPE}</td>
        <td>{Number(invoice.Taxable_Value_Books).toFixed(2)}</td>
        <td>{Number(invoice.CGST_Books).toFixed(2)}</td>
        <td>{Number(invoice.SGST_Books).toFixed(2)}</td>
        <td>{Number(invoice.IGST_Books).toFixed(2)}</td>
        <td>{Number(invoice.Cess_Books).toFixed(2)}</td>
        <td>{Number(invoice.Total_Amount_Books).toFixed(2)}</td>
        <td>{Number(invoice.Taxable_Value_GSTR6A).toFixed(2)}</td>
        <td>{Number(invoice.CGST_GSTR6A).toFixed(2)}</td>
        <td>{Number(invoice.SGST_GSTR6A).toFixed(2)}</td>
        <td>{Number(invoice.IGST_GSTR6A).toFixed(2)}</td>
        <td>{Number(invoice.Cess_GSTR6A).toFixed(2)}</td>
        <td>{Number(invoice.Total_Amount_Books_GSTR6A).toFixed(2)}</td>
      </tr>
    ));
  }, [loading, matchedInvoiceData?.record?.matched]);

  return (
    <BoxWrapper boxTitle="Reconciliation Status: Matched Invoice(s)">
      <div className={classes.ResponsiveTable}>
        <table className={classes.missingInAccountTableCss}>
          <thead>
            <tr>
              <th rowSpan={2}>GSTIN</th>
              <th rowSpan={2}>VENDOR NAME</th>
              <th rowSpan={2}>DOC NUMBER</th>
              <th rowSpan={2}>DOC DATE</th>
              <th rowSpan={2}>DOC TYPE</th>
              <th
                style={{ background: "#ffcc66" }}
                className={classes.booksHeader}
                colSpan={6}
              >
                As per Books
              </th>
              <th
                style={{ background: "#c6ffb3" }}
                className={classes.gstrHeader}
                colSpan={6}
              >
                As per GSTR6A
              </th>
            </tr>
            <tr>
              {[
                "TAXABLE VALUE",
                "CGST",
                "SGST",
                "IGST",
                "CESS",
                "TOTAL AMOUNT",
              ].map((label) => (
                <th
                  key={`books-${label}`}
                  style={{ background: "#ffcc66" }}
                  className={classes.booksHeader}
                >
                  {label}
                </th>
              ))}
              {[
                "TAXABLE VALUE",
                "CGST",
                "SGST",
                "IGST",
                "CESS",
                "TOTAL AMOUNT",
              ].map((label) => (
                <th
                  key={`gstr-${label}`}
                  style={{ background: "#c6ffb3" }}
                  className={classes.gstrHeader}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    </BoxWrapper>
  );
}

export default MatchedInvoice;
